<template>
  <div class="input-panel">
    <detail-section :title="title">
      <el-form
        ref="editForm"
        :model="editForm"
        :inline="true"
        :label-position="labelPosition"
        :rules="rules"
      >
        <el-form-item
          v-for="(item, i) in tableCol"
          :key="i"
          :label="item.label"
          :style="{ width: item.width }"
          :prop="item.bindValue"
        >
          <!-- 输入框 -->
          <el-input
            v-if="item.editType === 'input'"
            v-model="editForm[item.bindValue]"
            class="input-width"
          ></el-input>
          <!-- 计数器 -->
          <div v-else-if="item.editType === 'counter'" class="counter">
            <el-input-number v-model="editForm[item.bindValue]"></el-input-number>
            <span class="unit">{{ item.counterUnit }}</span>
          </div>
          <!-- 开关 -->
          <el-switch v-else-if="item.editType === 'switch'" v-model="editForm[item.bindValue]">
          </el-switch>
          <!-- 下拉选择 -->
          <el-select
            v-else-if="item.editType === 'select'"
            v-model="editForm[item.bindValue]"
            placeholder="请选择"
            @change="item.handleSelect && item.handleSelect()"
          >
            <el-option
              v-for="(elem, oIndex) in item.options"
              :key="oIndex"
              :label="elem.label"
              :value="elem.value"
            >
            </el-option>
          </el-select>
          <!-- 文件上传 -->
          <upload-files v-else :ref="item.bindValue"></upload-files>
        </el-form-item>
      </el-form>
    </detail-section>
  </div>
</template>

<script>
export default {
  name: 'InputPanel',
  props: {
    title: {
      type: String,
      default: ''
    },
    //显示label
    tableCol: {
      type: Array,
      default: () => {
        return []
      }
    },
    //绑定参数对象
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    //校验
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    editForm() {
      return this.form || {}
    }
  },
  methods: {
    //手动获取上传的文件
    getUploadFiles(refName) {
      return this.$refs[refName].getFileRaw()
    },
    getForm() {
      return this.editForm
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('input-panel', (
  --input-panel-unit-color: #fff
), (
  --input-panel-unit-color: #192227
));
.input-panel {
  @include adaptation(
    (
      --input-panel-form-item-label-height: 17px,
      --input-panel-form-item-label-margin-bottom: 8px,
      --input-panel-form-item-input-width: 246px,
      --input-panel-form-item-input-number-width: 246px,
      --input-panel-detail-section-content-padding: 12px 0 0,
    )
  );

  .cbaas-detail-section {
    /deep/ .content {
      padding: var(--input-panel-detail-section-content-padding);
    }
  }

  .el-form {
    /deep/ {
      .el-form-item__label {
        height: var(--input-panel-form-item-label-height);
        line-height: var(--input-panel-form-item-label-height);
        margin-bottom: var(--input-panel-form-item-label-margin-bottom);
      }

      .el-input {
        width: var(--input-panel-form-item-input-width);
      }

      .el-input-number--medium {
        width: var(--input-panel-form-item-input-number-width);
      }

      .unit {
        color: var(--input-panel-unit-color);
      }
    }
  }
}
</style>
